module.exports = __webpack_public_path__ + "img/logo-dom.0906923c.png";